module.exports = __webpack_public_path__ + "public/img/quan.3fdd232f.png";